// extracted by mini-css-extract-plugin
module.exports = {"item":"index_item_3DTIH","icon":"index_icon_1GVI1","setIcon":"index_setIcon_1SWV5","setIconActive":"index_setIconActive_wdkLQ","link":"index_link_1Onxt"};